/* Unbroken Vine — bundle selector.

   Deliberately small. Everything that costs money is server-side: the tier
   discounts are Shopify automatic discounts and the free bracelet is handled by
   gift-with-purchase.js. This file only keeps the visible state honest:
     1. the chosen tier writes its quantity into the product form
     2. picking a variant re-does the arithmetic against the new unit price

   It touches nothing else on the page, so a failure here leaves a working
   product form with whatever quantity was last set. */
(function () {
  'use strict';

  function money(cents) {
    /* Format like Liquid's money filter: the snippet renders a sample amount
       (123456) in the shopper's currency, and we reuse its symbol and separators. */
    var el = document.querySelector('bundle-selector[data-money-sample]');
    var sample = el ? el.dataset.moneySample : '';
    var fm = sample.match(/1(\D?)234(\D)56/);
    var n = (cents / 100).toFixed(2).split('.');
    if (!fm) return '$' + n[0] + '.' + n[1];
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, fm[1]);
    return sample.replace(fm[0], whole + fm[2] + n[1]);
  }

  class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.hidden_input = this.querySelector('[data-bundle-quantity]');
      this.options = Array.from(this.querySelectorAll('.bundle-selector__option'));

      this.addEventListener('change', this.onChange.bind(this));

      /* Tier discounts are set in US dollars. If Liquid priced them without the
         exchange rate (first page view in a non-USD currency), redo the maths. */
      var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
      var stale = this.options.some(function (o) {
        return Math.round((Number(o.dataset.amountOffUsd) || 0) * rate) !== (Number(o.dataset.amountOff) || 0);
      });
      if (stale) {
        this.options.forEach(function (o) {
          o.dataset.amountOff = Math.round((Number(o.dataset.amountOffUsd) || 0) * rate);
        });
        this.reprice(Number(this.dataset.unit), Number(this.dataset.compareUnit));
      }

      /* Dawn republishes the price block on variant change. Watch the section
         for that swap rather than guessing at an event name, because the event
         has been renamed twice across Dawn versions and the DOM has not. */
      var price = document.getElementById('price-' + this.sectionId());
      if (price) {
        this.observer = new MutationObserver(this.onVariantChange.bind(this));
        this.observer.observe(price, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    sectionId() {
      var form = this.dataset.form || '';
      return form.replace(/^product-form-/, '');
    }

    onChange(event) {
      if (!event.target.classList.contains('bundle-selector__radio')) return;
      var option = event.target.closest('.bundle-selector__option');
      if (!option) return;

      this.options.forEach(function (o) { o.classList.toggle('is-selected', o === option); });
      if (this.hidden_input) this.hidden_input.value = option.dataset.quantity;
    }

    /* Re-price every tier from the newly selected variant. The unit price is
       read out of Dawn's rendered price block, so there is one source of truth
       and no second fetch. */
    onVariantChange() {
      var el = document.querySelector('#price-' + this.sectionId() + ' .price-item--sale')
            || document.querySelector('#price-' + this.sectionId() + ' .price-item--regular');
      if (!el) return;
      var unit = this.parseMoney(el.textContent);
      if (!unit || unit === Number(this.dataset.unit)) return;

      /* The struck price scales with the variant too. Keep the ratio between
         compare-at and price so the savings stay honest after a variant swap. */
      var oldUnit = Number(this.dataset.unit) || unit;
      var oldCompare = Number(this.dataset.compareUnit) || oldUnit;
      this.reprice(unit, Math.round(unit * (oldCompare / oldUnit)));
    }

    reprice(unit, compareUnit) {
      this.dataset.unit = unit;
      this.dataset.compareUnit = compareUnit;
      var giftMin = Number(this.dataset.giftMin) || 0;

      this.options.forEach(function (option) {
        var qty = Number(option.dataset.quantity) || 1;
        var off = Number(option.dataset.amountOff) || 0;
        var compare = compareUnit * qty;
        var total = Math.max(unit * qty - off, 0);

        option.dataset.total = total;
        option.dataset.compare = compare;

        var priceEl = option.querySelector('.bundle-selector__price');
        if (priceEl) priceEl.textContent = money(total);

        var compareEl = option.querySelector('.bundle-selector__compare');
        if (compareEl) compareEl.textContent = compare > total ? money(compare) : '';

        var caption = option.querySelector('.bundle-selector__caption');
        if (caption && caption.dataset.captionTemplate) {
          caption.textContent = caption.dataset.captionTemplate
            .replace(/\[amount_saved\]/g, money(compare - total))
            .replace(/\[price\]/g, money(total))
            .replace(/\[compare_price\]/g, money(compare))
            .replace(/\[quantity\]/g, qty)
            .replace(/\[per_book\]/g, money(Math.round(total / qty)));
        }

        var gift = option.querySelector('.bundle-selector__gift');
        if (gift && giftMin) gift.hidden = total < giftMin;
      });
    }

    parseMoney(text) {
      var digits = (text || '').replace(/[^\d.,]/g, '').trim();
      if (!digits) return 0;
      /* "1.234,56" (comma decimal) vs "1,234.56" (period decimal): whichever
         separator comes last is the decimal one. */
      var lastComma = digits.lastIndexOf(',');
      var lastDot = digits.lastIndexOf('.');
      if (lastComma > lastDot) digits = digits.replace(/\./g, '').replace(',', '.');
      else digits = digits.replace(/,/g, '');
      return Math.round(parseFloat(digits) * 100) || 0;
    }
  }

  if (!customElements.get('bundle-selector')) {
    customElements.define('bundle-selector', BundleSelector);
  }
})();
